import { Checkbox, Col } from "antd";
import React, { useEffect, useState } from "react";
import doc5Service from "../../../services/doc5.service";

const BtnSendDoc5ListGroup = (props: { group: string; doc3Id: number }) => {
  const { group, doc3Id } = props;
  const [status, setStatus] = useState(true);

  useEffect(() => {
    (async () => {
      await doc5Service.checkStatusSend(doc3Id, group).then((res: any) => {
        // setDoc5List(res.data.length>0);
        // console.log(res.data);

        setStatus(res.data);
      });
    })();
  }, []);
  return (
    <Col key={group} span={4}>
      <Checkbox value={group} disabled={status}>
        {group}
      </Checkbox>
    </Col>
  );
};

export default BtnSendDoc5ListGroup;
